// extracted by mini-css-extract-plugin
export default {"w1000":"index_w1000_fPaRr","titA":"index_titA_zZAFI clearfix","spTit":"index_spTit_mqiU2","boxl":"index_boxl_Nyq80","boxr":"index_boxr_CDeME"};